// extracted by mini-css-extract-plugin
export default {"botaoHotmart":"cursos_botaoHotmart__fg9df"};